export const ERROR = 'danger';
export const WARN = 'warning';
export const INFO = 'info';
export const SUCCESS = 'success';